module.exports = __webpack_public_path__ + "img/img-placeholder-1-1.5033921d.svg";